function News_form_edit(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    checkboxTopnews: '.js-checkbox-topnews',
	    containerTopnews: '.js-container-topnews',
	    containerSettings: '.js-container-settings'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded'
    };

    this.init = function() {
	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$checkboxTopnews = this.$element.find(this.selectors.checkboxTopnews);
	    this.$containerTopnews = this.$element.find(this.selectors.containerTopnews);
	    this.$containerSettings = this.$element.find(this.selectors.containerSettings);

	    this.$checkboxTopnews.on('i4:change', this.$onChangeTopnews.bind(this));

		this.$formParent.on(this.triggers.afterLoaded, (function() {
			this.$onChangeTopnews();
		}).bind(this));
    };

    this.$onChangeTopnews = function() {
    	if (this.$checkboxTopnews.is(':checked')) {
			this.$containerTopnews.show();
			this.$containerSettings.hide();
		} else {
			this.$containerTopnews.hide();
			this.$containerSettings.show();
		}
    };
}
